export default "__VITE_ASSET__KKavk41J__"